/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingPermissionKey {
  static readonly EMPLOYEE = 'time-recording/permission/employee';

}
